import Api from "../../../../shared/network/axiosClients";
import { AxiosResponse } from "axios";

export const logout = async (): Promise<AxiosResponse> => {
  return Api.post("users/logout");
};
